import type { StudioType } from '@conversed/shared/src/central/types/studio.type';

/**
 * Tells whether a route is available for the current studio type. A route
 * without studio types, or with an empty list, carries no studio restriction
 * and stays available in every studio.
 */
export const isRouteAllowedForStudioType = (
  routeStudioTypes: StudioType[] | undefined,
  currentStudioType?: StudioType,
): boolean => {
  if (!routeStudioTypes || routeStudioTypes.length === 0) {
    return true;
  }

  if (!currentStudioType) {
    return false;
  }

  return routeStudioTypes.includes(currentStudioType);
};
